import "./css/app.css"
import Footer from "./../footer/footer"

const UserApp = () => {
    return (
        <div className="pageWrapper">
            <div className="appMainContainer">
                <div className="appMessageBox">
                    <div className="appIcon">
                        <i className="fa-solid fa-mobile-screen-button"></i>
                    </div>
                    <h3>Mobile App Coming Soon</h3>
                    <div className="appMessage">
                        We are currently developing a mobile app for Android and plan to launch it as soon as possible.
                        Once available, the app will be our primary platform, and it will be downloadable via the Google
                        Play Store. In the meantime, we invite you to enjoy our full range of services on our website.
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}
export default UserApp